export const FOREX_APPROVAL_MODULE_NAME: string = 'approval';

export enum ForexApprovalGetter {
	list = 'list',
	loading = 'loading',
	operationType = 'operationType',
	toApprovalCount = 'toApprovalCount',
	paymentOrderCount = 'paymentOrderCount',
	allCount = 'allCount',
}

export enum ForexApprovalMutation {
	addList = 'addList',
	setLoading = 'setLoading',
	deleteItems = 'deleteItems',
	setNextPage = 'setNextPage',
	resetPage = 'resetPage',
	resetFilter = 'resetFilter',
	setIsEndPage = 'setIsEndPage',
	setOperationType = 'setOperationType',
	setPaymentOrderCount = 'setPaymentOrderCount',
	setToApprovalCount = 'setToApprovalCount',
}

export enum ForexApprovalAction {
	loadNextPage = 'loadNextPage',
	loadPage = 'loadPage',
	reloadPage = 'reloadPage',
	deleteItems = 'deleteItems',
	loadPaymentOrderCount = 'loadPaymentOrderCount',
	loadToApprovalCount = 'loadToApprovalCount',
	loadCount = 'loadCount',
}